var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.src,"srcset":_vm.srcset,"alt":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }